export default "__VITE_ASSET__tDYwfOgQ__"